import administrador from './administrador'
import desactivado from './desactivado'
import instructor from './instructor'
import profesor from './profesor'
import superadministrador from './superadministrador'

const abilities = {
  administrador: [...administrador],
  desactivado: [...desactivado],
  instructor: [...instructor],
  profesor: [...profesor],
  superadministrador: [...superadministrador]
}

export default abilities
